import { NextSeo } from 'next-seo';
import TheProfilePage from '../../components/TheProfilePage';
import config from '../../config';

export default function ProfilePage() {
  const title = `Profile`;
  const description = `View your Shitty Kitties, Shitty Cities, Achievements, and more.`;

  return (
    <>
      <NextSeo title={`Profile - ${config.siteName}`} description={description} />
      <TheProfilePage title={title} description={description} />
    </>
  );
}
